import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../api/auth";
import "./LoginView.css";

export default function ForgotPasswordView() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await authApi.forgotPassword(email);
      setMessage(r.message);
    } catch {
      // Router always returns 200 with a generic message for this endpoint,
      // so a thrown error here means something else (network, 5xx).
      setMessage("Something went wrong — try again shortly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <h1>Reset password</h1>
        {message ? (
          <p>{message}</p>
        ) : (
          <>
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>
            <button type="submit" disabled={loading}>
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}
        <div className="login-footer-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
